// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"231":"7a39967d","393":"e9c5ecd0","528":"f756bb42","916":"2ddf3fe9"}[chunkId] + ".css";
};